import { createSelector } from '@reduxjs/toolkit';
import { AccountState } from '../types/account.type';
import moment from 'moment/moment';

interface RootState {
    account: AccountState;
}

export const selectAccountInfo = (state: RootState) => state.account.accountInfo;

export const selectAccountState = (state: RootState) => state.account;

export const selectAccountId: (state: RootState) => string | undefined = createSelector(
    selectAccountInfo,
    (accountInfo): string | undefined => accountInfo?.id
);

export const selectIsAccountLoggedIn: (state: RootState) => boolean = createSelector(
    selectAccountState,
    (state): boolean => Boolean(state?.isLoggedIn)
);

export const selectAccountAge: (state: RootState) => number | undefined = createSelector(
    selectAccountInfo,
    (accountInfo): number | undefined => accountInfo?.age
);

export const selectdateOfBirthIntegrity = (state: RootState) => state.account.dateOfBirthIntegrity;

export const selectAccountEmail = (state: RootState) => state.account?.accountInfo?.email;

export const selectIsConfirmingAge: (state: RootState) => boolean = createSelector(
    selectAccountState,
    (state): boolean => Boolean(state?.isConfirmingAge)
);

export const selectAccountIsUnder18: (state: RootState) => boolean = createSelector(
    selectAccountState,
    (accountState): boolean => {
        const accountInfo = accountState?.accountInfo;
        if (!accountInfo?.dateOfBirth) {
            return false;
        }
        const today = moment();
        const age = today.diff(accountInfo?.dateOfBirth, 'years');
        return age < 18;
    }
);
